import { socket } from "@/lib/socket";
import { OverlaySocket } from "@ailenax-overlay/shared";
import { createContext } from "react";

export const SocketContext = createContext<OverlaySocket>(socket);

